/* ============================================================================
 * ty-pdp-title.js · כותרת דף המוצר: 26 בטלפון, רק כשנשברת · 08.09.2026
 * ----------------------------------------------------------------------------
 * הכלל: בטלפון (עד 749), אם הכותרת נשברת לשתי שורות בגודל המלא, מוסיפים
 * ty-pdp-title--fit ו-ty-pdp-title.css מוריד אותה ל-26. אחרת לא נוגעים.
 *
 * 🔴 השרת אינו יכול לדעת רוחב. ספירת תווים תופסת את כל 53 הכותרות הנשברות
 *    רק אם מקטינים גם 15 עד 20 שאינן צריכות. נמדד על 138 מוצרים.
 * 🔴 מודדים אחרי טעינת הגופן (document.fonts.ready). מדידה על גופן החלופה
 *    מחזירה רוחב אחר לגמרי.
 * 📌 מספר השורות נמדד ב-Range על תוכן האלמנט, לפי ערכי top ייחודיים.
 *    getClientRects על אלמנט בלוק מחזיר תיבה אחת תמיד, ושורה דו-כיוונית
 *    מחזירה כמה תיבות באותו top. שני הירוקים הכוזבים מתועדים בחוקה.
 * ========================================================================== */
(function () {
  'use strict';
  var FIT = 'ty-pdp-title--fit';
  var mq = window.matchMedia('(max-width: 749px)');

  function lineCount(el) {
    var r = document.createRange();
    r.selectNodeContents(el);
    var rects = r.getClientRects(), seen = {}, n = 0;
    for (var i = 0; i < rects.length; i++) {
      if (rects[i].width < 1) continue;
      var k = Math.round(rects[i].top);
      if (!seen[k]) { seen[k] = 1; n++; }
    }
    return n;
  }

  function fit() {
    var els = document.querySelectorAll('h1.ty-pdp-title');
    for (var i = 0; i < els.length; i++) {
      var h = els[i];
      h.classList.remove(FIT);
      if (mq.matches && lineCount(h) > 1) h.classList.add(FIT);
    }
  }

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(fit);
    if (document.fonts.addEventListener) document.fonts.addEventListener('loadingdone', fit);
  } else {
    fit();
  }
  var t;
  window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(fit, 120); });
  window.addEventListener('orientationchange', function () { setTimeout(fit, 200); });
})();
